import api from "../store/services/api";

export const addressCoordinates = async (
  street,
  houseNumber,
  neighborhood,
  city
) => {
  const res = await api.get(
    `/latlng/?street=${street}&house_number=${houseNumber}&neighborhood=${neighborhood}&city=${city}`
  );
  const { latitude, longitude } = res.data;
  return {
    lat: latitude,
    lng: longitude,
  };
};

export const calculateDistance = async (lat1, lng1, lat2, lng2) => {
  return await api.get(`/latlng/distance/`, {
    params: {
      lat1: lat1,
      lon1: lng1,
      lat2: lat2,
      lon2: lng2,
    },
  });
};

export const createAddress = (address) =>
  api.post(`/addresses/`, address, {
    headers: { "Content-Type": "application/json" },
  });

export const editAddress = (addressId, address) =>
  api.put(`/addresses/?aid=${addressId}`, address, {
    headers: { "Content-Type": "application/json" },
  });

const AddressService = {
  addressCoordinates,
  createAddress,
  editAddress,
  calculateDistance,
};

export default AddressService;
